import { render, staticRenderFns } from "./commonLabel.vue?vue&type=template&id=e7915d3a&scoped=true"
import script from "./commonLabel.vue?vue&type=script&lang=js"
export * from "./commonLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7915d3a",
  null
  
)

export default component.exports